const base64UrlEncode = (bytes: Uint8Array): string => {
	let binary = ""
	for (const byte of bytes) {
		binary += String.fromCharCode(byte)
	}
	return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")
}

/**
 * Generates a PKCE code_verifier per RFC 7636 (43-128 char base64url string)
 */
export const generateCodeVerifier = (): string => {
	const randomBytes = crypto.getRandomValues(new Uint8Array(32))
	return base64UrlEncode(randomBytes)
}

/**
 * Derives the S256 PKCE code_challenge for a given code_verifier
 */
export const generateCodeChallenge = async (verifier: string): Promise<string> => {
	const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier))
	return base64UrlEncode(new Uint8Array(digest))
}
